import { PriceFreezeFunnelProvider } from './PriceFreezeFunnelProvider';
import { withPriceFreezeContext } from '@/withPriceFreezeContext';

const _PriceFreezeProvider = withPriceFreezeContext(PriceFreezeFunnelProvider);

export { PriceFreezeFunnelProvider, _PriceFreezeProvider };
